import { createSelector } from 'reselect'
import concat from 'lodash/concat'
import { AppState } from 'Store'

const getAll = (state: AppState) => state.coliseum.call.call
const getEntries = (state: AppState) => state.coliseum.call.call.entries
const getAllTotal = (state: AppState) => state.coliseum.call.call.total_entries
const getRequestParams = (state: AppState) => state.coliseum.call.requestParams
const getAllCallStatus = (state: AppState) => state.coliseum.call.callStatus
const getAllStatus = (state: AppState) => state.coliseum.call.status
const getAllPotentialClientStatus = (state: AppState) => state.coliseum.call.potentialClientStatus
const getOne = (state: AppState) => state.coliseum.call.call
const getCause = createSelector(getAllStatus, getAllCallStatus, (statuses, callStatuses) => {
	return concat(callStatuses, statuses)
})
const selectFormState = (state: AppState) => state.coliseum.call.formState
export const callSelectors = {
	getAll,
	getAllTotal,
	getRequestParams,
	getAllCallStatus,
	getAllStatus,
	getOne,
	getCause,
	getAllPotentialClientStatus,
	getEntries,
	selectFormState,
}
